export const TRANSFER_ORDER_FILE_CONSTRAINTS = {
    entityType: 'TransferOrder',
    sourceCollection: 'transfer_order',
    maxBytes: 10 * 1024 * 1024,
    maxCount: 20,
    allowedMimeTypes: ['application/pdf', 'image/png', 'image/jpeg', 'image/webp'],
};
//# sourceMappingURL=file-constants.js.map